export default {
  'assessmentContext.title': 'Değerlendirme Bağlamı',
  'assessmentContext.subtitle':
    'Değerlendirmenizin birim ve ders yapısını tasarlayın',
  'assessmentContext.unitCourse': 'BİRİMLER / DERSLER',
  'assessmentContext.noUnitSelected':
    'Sınav kurulumuna devam etmek için birim veya ders seçin.',
};
